import React, { useState } from 'react';
import PhotoFullscreenModal from '../../common/PhotoFullscreenModal/PhotoFullscreenModal';
import { StudentPhoto, PhotoPosition } from '../../../types';
import { PHOTO_POSITION_LABELS } from '../../../constants';
import styles from './PhotoGallery.module.css';

interface PhotoGalleryProps {
  photos: StudentPhoto[];
}

const ALL_POSITIONS: PhotoPosition[] = ['front', 'back', 'right', 'left'];

const PhotoGallery: React.FC<PhotoGalleryProps> = ({ photos }) => {
  const [fullscreenPreview, setFullscreenPreview] = useState<{ src: string; alt: string } | null>(null);
  const photoMap = new Map<PhotoPosition, StudentPhoto>();
  photos.forEach((photo) => photoMap.set(photo.position, photo));

  return (
    <>
      <div className={styles['photo-grid']}>
        {ALL_POSITIONS.map((position) => {
          const photo = photoMap.get(position);
          return (
            <div key={position} className={styles['photo-item']}>
              {photo ? (
                <>
                  <button
                    type="button"
                    className={styles['photo-image-button']}
                    onClick={() => setFullscreenPreview({
                      src: photo.url,
                      alt: PHOTO_POSITION_LABELS[position],
                    })}
                    title="Ver em tela cheia"
                    aria-label={`Ver ${PHOTO_POSITION_LABELS[position]} em tela cheia`}
                  >
                    <img
                      src={photo.url}
                      alt={PHOTO_POSITION_LABELS[position]}
                      className={styles['photo-image']}
                    />
                  </button>
                  <div className={styles['photo-label']}>{PHOTO_POSITION_LABELS[position]}</div>
                </>
              ) : (
                <>
                  <div className={styles['photo-placeholder']}>Sem foto</div>
                  <div className={styles['photo-label']}>{PHOTO_POSITION_LABELS[position]}</div>
                </>
              )}
            </div>
          );
        })}
      </div>

      <PhotoFullscreenModal
        open={Boolean(fullscreenPreview)}
        src={fullscreenPreview?.src ?? ''}
        alt={fullscreenPreview?.alt}
        onClose={() => setFullscreenPreview(null)}
      />
    </>
  );
};

export default PhotoGallery;
